import {
  ActionBehavior,
  IconType
} from '@rappider/rappider-components/utils';
import { CardListConfig } from '@rappider/rappider-components';

/**
 * Card list configuration for displaying copied projects
 *
 * Defines the card display settings for copied project modules
 * including field mappings and action buttons.
 */
export const copiedProjectsCardConfig: CardListConfig = {
  titleFieldName: 'name',
  descriptionFieldName: 'description',
  getDescriptionFunction: (item: any) => {
    const descriptionText = item?.description;
    if (descriptionText) {
      return {
        content: descriptionText,
        text: descriptionText
      };
    }
    return null;
  },
  subtitleFieldNames: ['createdBy', 'createdDate'],
  deleteItemActionButton: {
    name: 'delete-module',
    icon: {
      name: 'delete',
      type: IconType.NgZorro
    },
    tooltipText: 'Delete Module',
    behavior: ActionBehavior.Emit,
    popconfirmTitle: 'Are you sure to delete this module from your project?',
    popconfirmOkDanger: true,
    popconfirmOkText: 'Delete',
    emitWithoutPopconfirm: false
  }
};
